<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'AKQUISEOBJEKTE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16 flex flex-column gap-16">
    @if (canCreate()) {
      <work-ui-button [fullWidth]="true"
                      iconName="add_location_alt"
                      routerDirection="forward"
                      routerLink="/mitarbeitende/akquise/neu"
                      text="AKQUISEOBJEKT_ERFASSEN" />
    }

    <div class="work-buttons">
      <work-ui-button (buttonClick)="setScope('mine')"
                      [variant]="scope() === 'mine' ? 'primary' : 'secondary'"
                      size="small"
                      text="AKQUISE_MEINE" />
      <work-ui-button (buttonClick)="setScope('all')"
                      [variant]="scope() === 'all' ? 'primary' : 'secondary'"
                      size="small"
                      text="ALLE" />
    </div>

    <work-ui-input-field (valueChange)="onSearchChange($event)"
                         [(loadingState)]="loadingState"
                         iconName="search"
                         label="SUCHEN"
                         placeholder="AKQUISE_SUCHEN_PLACEHOLDER" />

    @for (group of prospectsByCity(); track group.city) {
      <div class="flex flex-column gap-8">
        <h3>{{ group.city }}</h3>
        @for (prospect of group.prospects; track prospect.id) {
          @let statusBadge = prospect.status | prospectStatusBadge;
          @let contactName = prospect | getFullnameOfContact;
          <div [routerLink]="['/mitarbeitende/akquise/details', prospect.id]"
               class="work-card padding-narrow flex flex-row space-between vertical-center gap-12"
               routerDirection="forward">
            <div class="flex flex-column gap-4">
              @if (prospect.status !== 'open') {
                <work-ui-badge [text]="statusBadge.text" [variant]="statusBadge.variant" size="small" />
              }
              <h4>{{ prospect.objectStreet || ('OHNE_STRASSE' | translate) }}</h4>
              @if (prospect.title) {
                <p>{{ prospect.title }}</p>
              }
              @if (contactName) {
                <p><small class="work-text-color-light">{{ contactName }}</small></p>
              }
            </div>
            <div class="flex flex-row vertical-center gap-4 work-text-color-light">
              @if (prospect.documentCount) {
                <small>{{ prospect.documentCount }}</small>
                <work-ui-icon name="photo_camera" />
              }
              <work-ui-icon name="arrow_forward" />
            </div>
          </div>
        }
      </div>
    } @empty {
      @if (hasLoaded() && loadingState() === 'none') {
        <p class="work-text-color-light">{{ (searchTerm() ? 'KEINE_SUCHTREFFER' : 'AKQUISE_KEINE_OBJEKTE') | translate }}</p>
      }
    }
  </div>
</ion-content>
